<!-- ==================================== -->
<!-- POPUP OF DETAILS -->
<!-- ==================================== -->
<!-- <div id="content" #content> -->

<div class="overlay" *ngIf="showOverlayPopup">
    <div class="popup">
        <div class="colse-popup" (click)="showOverlayPopup = false">
            <img src="../../../assets/images/closeIcon.svg" />
        </div>
        <div class="popup-title">
            <p>تفاصيل</p>
        </div>
        <div class="popup-img">
            <img src="../../../assets/images/popupImg.svg" />
        </div>
        <div class="popup-text">
            <p style="margin-bottom: 30px">
                هذا مثال لنص يمكن أن يستبدل في نفس المساحة هذا مثال لنص يمكن أن
                يستبدل في نفس المساحة هذا مثال لنص يمكن أن يستبدل في نفس المساحة
                هذا مثال لنص يمكن أن يستبدل في نفس المساحة
            </p>
            <p>
                هذا مثال لنص يمكن أن يستبدل في نفس المساحة هذا مثال لنص يمكن أن
                يستبدل في نفس المساحة هذا مثال لنص يمكن أن يستبدل في نفس المساحة
                هذا مثال لنص يمكن أن يستبدل في نفس المساحة
            </p>
        </div>
    </div>
</div>

<!-- ================================================ -->
<!-- POPOUP For SEARCH -->
<!-- ================================================ -->

<div class="overlay-taslsoli" *ngIf="ShowSearch">
    <div class="popup">
        <h2>اختيار المخطط</h2>
        <div class="input-field">
            <label for="baladeya"> البلدية </label>
            <select id="baladeya" (change)="onBaladeyaNameChange($event)">
                <option value="">All</option>
                <option *ngFor="let option of baladeyaNameOptions" [value]="option">
                    {{ option }}
                </option>
            </select>
        </div>

        <div class="input-field">
            <label for="planName"> اسم الحي </label>

            <select id="planName" (change)="onNeighNameChange($event)">
                <option value="">All</option>
                <option *ngFor="let option of neighNameOptions" [value]="option">
                    {{ option }}
                </option>
            </select>
        </div>

        <div class="input-field">
            <label for="planNum"> رقم المخطط </label>

            <select id="planNum" (change)="onPlanNumChange($event)">
                <option value="">All</option>
                <option *ngFor="let option of planNumOptions" [value]="option">
                    {{ option }}
                </option>
            </select>
        </div>

        <!-- <div class="input-field">
        <label for="planName"> اسم المخطط </label>
       
        <select id="planName" (change)="onPlanNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of planNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div> -->
        <!-- <div class="input-field">
        <label for="parcelno"> رقم القطعة </label>
        
        <select id="parcelno" (change)="onParcelNoChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of parcelNoOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>  -->
    </div>
</div>

<!-- ====================================== -->
<!-- table -->
<!-- ====================================== -->

<div class="table-overlay" [ngStyle]=" { 'pointer-events': ShowTable ? 'unset' : 'none' }"
    [ngClass]="ShowTable ? 'show-tabel' : 'hidden-table'">
    <div class="table-popup">
        <div class="attributeContent">
            <div id="attributeTable" style="pointer-events: all"></div>
        </div>
    </div>
</div>

<!-- ====================================== -->
<!-- THE MAIN PAGE -->
<!-- ====================================== -->


<div id="content" #content style="direction: rtl"
    class="flex flex-col h-dvh bg-[#FDFDFD] md:overflow-hidden md:overscroll-none">
    <app-nav [class]="fullscreen ? 'hidden' : ''" (onSearchChange)="startSearch($event)"></app-nav>
    <div [class]="fullscreen ? 'flex' : 'flex md:h-[95%] flex-row nav-container'">
        <!-- Right Section -->


        <div *ngIf="!fullscreen" class="w-full md:w-[15%] 2xl:h-full  ">




            
            <section class="sub-section   flex flex-col 2xl:py-2   2xl:space-y-2 " >
                <app-info-label #allBaladey [lable]="'كل البلديات'" [lable2]="''" [info]="''" [info2]="''"
                    [isChecked]="true" [isCheckable]="true" (onCheckChange)="
                        onBaladyaSelection($event, -1); filterSelectedBaladya()
                    " (onCheckChange1)="fn($event)"></app-info-label>
                <app-info-label *ngFor="let center of baladyasList; index as i" [lable]="center.lable" 
                    [lable2]="center.lable2" [info]="center.info" [info2]="center.info2" [isChecked]="center.isChecked"
                    [isCheckable]="true" (onCheckChange)="
                        onBaladyaSelection($event, i); filterSelectedBaladya()
                    " (onCheckChange1)="fn($event)"></app-info-label>
            </section>
            <section class="sub-section my-2 flex flex-col py-3 px-2" style="padding: 0">
                <label class="font-semibold xl-plus:mb-2 grad-main-color text-transparent bg-clip-text self-start text-nowrap"
                    for="planCase"> حالة المخطط </label>
                <select class="select-default h-7 2xl:h-11" id="planCase" [(ngModel)]="selectedPlanCase"
                    (change)=" onPlanCasesChange($event);">
                    <option value="">All</option>
                    <option *ngFor="let option of planCaseOptions" [value]="option">
                        {{ option }}
                    </option>
                </select>

            </section>
            <section class="gap-2 xl-plus:gap-2 flex flex-col ">
                <!-- <app-info-pie
                    #madinahArialpercent
                    class="sub-section"
                    lable="نسبة إنجاز التصوير الجوي"
                    [percentage]="
                        staticsData?.pieData?.aerialPhotographyPercentage ?? 0
                    "
                ></app-info-pie> -->

                 
                <app-arc-percentage-lable #Donepercent label="إجمالي المنجز" class="sub-section   2xl:min-h-40 " [percentage]="
                        staticsData?.pieData?.totalScannedPercentage ?? 0
                    " [selectedBaladyas]="selectedBaladyaArr"></app-arc-percentage-lable>
                    
                <app-info-pie #baladypercent class="sub-section   2xl:min-h-52" lable="نسبة إنجاز بلدي 2"
                    [percentage]="staticsData?.pieData?.baladyPercentage ?? 0"></app-info-pie>
                
                <!-- <app-info-gauge
                    #Donepercent
                    class="sub-section"
                    lable="إجمالي المنجز"
                    [percentage]="
                        staticsData?.pieData?.totalScannedPercentage ?? 0
                    "
                ></app-info-gauge> --> 
                <app-arc-percentage-lable label="نسبة الإنجاز للمشروع" class="sub-section   2xl:min-h-40" [percentage]="
                        staticsData?.statics?.allProjectProgressPercentage ?? 0
                    "></app-arc-percentage-lable>
                    
            </section>
        </div>


        <!-- Left Section -->
        <div class="flex flex-col w-full md:h-dvh ">
            <section *ngIf="!fullscreen" class="md:h-[18%] lg:h-[15%] mx-2 mt-2 flex gap-4 justify-between ">
                <div class="sub-section-bordered w-full ">
                    <app-info-label class="mt-auto text-lg lg:text-base"
                        [info]="(staticsData?.statics?.targetedPlansCount?.toString() ?? 0) + ' مخطط'" [vertical]="true"
                        icon="./assets/Group 1171275911.svg" lable="المخططات المستهدفة " />
                    <app-info-label class="mt-auto text-lg lg:text-base"
                        [info]="(staticsData?.statics?.totalAreasCount?.toString() ?? 0) + ' قطعة'" [vertical]="true"
                        icon="./assets/images/allLands.svg" lable="إجمالي قطع الأراضي" />
                    <app-info-label class="mt-auto text-lg lg:text-base"
                        [info]="(staticsData?.statics?.totalAreasSize?.toString() ?? 0) + 'كم²'" [vertical]="true"
                        icon="./assets/images/square.svg" lable="إجمالي المساحة" />
                </div>

                <div class="sub-section flex flex-col w-full  ">
                    <app-info-label class="flex-1  "
                        [info]="staticsData?.statics?.pending?.toString() ?? 0" lable="جاري العمل" arcColor="#E89315"
                        [percentage]="staticsData?.statics?.pendingPercent?.toString() ?? 0" info2="مخطط" />
                    <app-info-label class="flex-1  "
                        [info]="staticsData?.statics?.cancelled?.toString() ?? 0" lable="مخالف للمعايير" arcColor="red"
                        [percentage]="staticsData?.statics?.cancelledPercent?.toString() ?? 0" info2="مخطط" />
                    <app-info-label class="flex-1  "
                        [info]="staticsData?.statics?.notCorrected?.toString() ?? 0" lable="لم يتم العمل"
                        arcColor="#707070" [percentage]="staticsData?.statics?.notCorrectedPercent?.toString() ?? 0"
                        info2="مخطط" />
                </div>

                <div class="sub-section flex flex-col  w-full  ">   
                    <app-info-label class="flex-1   "
                        [info]="staticsData?.statics?.qualityControl?.toString() ?? 0" lable="ضبط الجودة"
                        arcColor="#61E42A" [percentage]="staticsData?.statics?.qualityControlPercent?.toString() ?? 0"
                        info2="مخطط" />
                    <app-info-label class="flex-1  "
                        [info]="staticsData?.statics?.corrected?.toString() ?? 0" lable="تم التصحيح" arcColor="#106D19"
                        [percentage]="staticsData?.statics?.correctedPercent?.toString() ?? 0" info2="مخطط" />
                    <app-info-label class="flex-1  "
                        [info]="staticsData?.statics?.planApproval?.toString()" lable="تم الاعتماد" arcColor="#217ED3"
                        [percentage]="staticsData?.statics?.planApprovalPercent?.toString() ?? 0" info2="مخطط" />
                </div>

                <div class="sub-section-bordered w-full  ">
                    <app-info-label class="mt-auto text-lg lg:text-base" icon="./assets/Group 1171275916.svg"
                        [info]="(staticsData?.statics?.deliveredToRER?.toString() ?? 0) + ' مخطط'" [vertical]="true"
                        lable="تم التسليم ل RER  " />
                    <app-info-label class="mt-auto text-lg lg:text-base" icon="./assets/Group 1171275916.svg"
                        [info]="(staticsData?.statics?.isAdvertised?.toString() ?? 0) + ' مخطط'" [vertical]="true"
                        lable="تم الإعلان   " />
                    <app-info-label class="mt-auto text-lg lg:text-base" icon="./assets/Group 1171275916.svg"
                        [info]="(staticsData?.statics?.isAdInProgress?.toString() ?? 0) + ' مخطط'" [vertical]="true"
                        lable="جار الإعلان" />
                </div>
            </section>

            <!-- MAP -->
            <section [class]="fullscreen ? 'size-full' : 'm-2 h-[70%] lg:h-[74%]'"
                style="padding: 0px; margin-top: 0px">
                <div class="sub-section h-full relative" style="padding: 0px">
                    <div class="map-container">
                        <div class="mapView" #mapView></div>

                        <!-- START RIGHT MENU BAR (Keeping Everything) -->
                        <div id="elementToHide">
                            <button class="h-10 w-10 absolute left-[30px] top-[30px] z-[10000]"
                                (click)="toggleFullScreen()">
                                <img src="../../../assets/images/fullScreen.svg" />
                            </button>

                            <button class="tglBtn absolute left-[85px] top-[32.5px] z-[10000]"
                                (click)="toggleMeasurements()">
                                <img src="../../../assets/measurements.svg" alt="Measurement" />
                            </button>

                            <div [hidden]="measurementsVisible" id="measurmentToolbar"
                                class="measurement-tools esri-component esri-widget rounded-full expanded-tools">
                                <button id="distance"
                                    class="esri-widget--button esri-interactive esri-icon-measure-line"
                                    title="Distance Measurement Tool"></button>
                                <button id="area" class="esri-widget--button esri-interactive esri-icon-measure-area"
                                    title="Area Measurement Tool"></button>
                                <button id="clear" class="esri-widget--button esri-interactive esri-icon-trash"
                                    title="Clear Measurements"></button>
                            </div>

                            <div class="btn-sidemenu-icon">
                                <button class="btns btn-tabel mov" (click)="showtableFun()">
                                    <img src="../../../assets/images/tabel.svg" />
                                </button>
                                <button class="btns btn-sub-search mov" (click)="ShowSearchFun()">
                                    <img src="../../../assets/images/hand.svg" />
                                </button>
                                <button class="btns btn-home mov" (click)="zoomToHome()">
                                    <img src="../../../assets/images/homeIcon.svg" />
                                </button>
                                <button class="btns btn-prev mov" id="zoomPrevBtn" (click)="zoomToPreviousExtent()">
                                    <img src="../../../assets/images/prevIcon.svg" />
                                </button>
                                <button class="btns btn-next mov" id="zoomNextBtn" (click)="zoomToNextExtent()">
                                    <img src="../../../assets/images/nextIcon.svg" />
                                </button>
                                <button class="btns btn-layers mov" (click)="openLayerPopup()">
                                    <img src="../../../assets/images/layerIcon.svg" />
                                </button>
                                <button class="btns btn-switch-map mov" (click)="openSwitchMapPopup()">
                                    <img src="../../../assets/images/switchMapIcon.svg" />
                                </button>
                                <button class="btns btn-details mov" (click)="poenDetailsPopup()">
                                    <img src="../../../assets/images/detailsIcon.svg" />
                                </button>
                                <button class="btns btn-details mov" (click)="printDocument()">
                                    <img src="../../../assets/images/icons8-print-24.png" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section *ngIf="!fullscreen" class="mx-2 h-[25%] lg:h-[20%] collapse">
                <div class="sub-section w-full h-26">
                    <app-horizental-timeline [allInjazpercent]="allInjaz"></app-horizental-timeline>
                </div>
            </section>
        </div>

    </div>

</div>


<!-- ====================================== -->
<!-- END OF THE MAIN PAGE -->
<!-- ====================================== -->

<!-- ================================ -->
<!-- START BOTTOM CHARTS -->
<!-- ================================ -->
<div class="bottom-content-charts collapse">
    <!-- ----------------------------------------- -->
    <div class="two-charts">
        <div class="chart">
            <canvas id="MyChart1"></canvas><!--9 -->
        </div>
        <div class="chart">
            <canvas id="MyChart2"></canvas><!--6 -->
        </div>
    </div>
</div>

<!-- ====================================== -->
<!-- START LEFT CHARTS -->
<!-- ====================================== -->

<!-- <div class="left-content-charts collapse">
    
    <div class="two-charts">
        <div class="chart">
            <canvas id="MyChart3"></canvas>
        </div>
        <div class="chart">
            <canvas id="MyChart4"></canvas>
        </div>
    </div>
    
    <div class="two-charts">
        <div class="chart">
            <canvas id="MyChart9"></canvas>
        </div>
        <div class="chart">
            <canvas id="MyChart6"></canvas>
        </div>
    </div>
    

    <div class="card-details">
        <div class="card-text">
            <h4>عدد القطع</h4>
            <p>{{ parcelCountSum }}</p>
        </div>
        <div class="card-icon">
            <img src="assets/images/card-details-icon1.png" alt="" />
        </div>
    </div>


    <div class="card-details">
        <div class="card-text">
            <h4>مساحة القطع</h4>
            <p>{{ parcelAreaSum }}</p>
        </div>
        <div class="card-icon">
            <img src="assets/images/card-details-icon2.png" alt="" />
        </div>
    </div>

    <div class="small-cards">
        <div>
            <p>البلدية: {{ baladeyaLegendName }}</p>
        </div>
        <div>
            <p>النطاق: {{ zoneLegendName }}</p>
        </div>
    </div>
</div> -->

<!-- ================================ -->
<!-- START RIGHT CHARTS -->
<!-- ================================ -->

<!-- <div class="right-content-charts collapse">
    
    <div class="two-charts">
        <div class="chart">
            <canvas id="MyChart7"></canvas>
        </div>
        <div class="chart">
            <canvas id="MyChart8"></canvas>
        </div>
    </div>
   
    <div class="one-chart">
        <div class="chart">
            <canvas id="MyChart5"></canvas>
        </div>
    </div>
</div> -->


<!-- </div> -->